import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import {MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import { forkJoin, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PageStatus } from '../models/page-status';
import { SummaryPage } from '../models/summary-page';
import { StatusPageService } from '../services/status-page.service';
import {ActivatedRoute} from '@angular/router';

/**
 * @title Tab group with aligned labels
 */
@Component({
  selector: 'app-tabs-component',
  templateUrl: 'tabs-component.html',
  styleUrls: ['tabs-component.css'],
})
export class TabsComponent implements OnInit {
  @ViewChild('tabs') tabGroup: MatTabGroup;

  public Detail = new Array<SummaryPage>();
  public Unavailable = new Array<SummaryPage>();

  constructor(
    private statusPageService: StatusPageService,
    private route: ActivatedRoute
  ) { }

  selectedIndex: number;

  ngOnInit(): void {
    const statusPages: Array<SummaryPage> = environment.statusPages;
    const allObs = new Array<Observable<PageStatus>>();

    statusPages.forEach(page => {
      allObs.push(this.statusPageService.GetPageStatus(page.statusPageUrl + page.statusUrl));
    });

    forkJoin(allObs)
        .subscribe(
        (data) => {
          data.forEach((obj, index) => {
            if (obj instanceof HttpErrorResponse) {
              this.Unavailable.push(statusPages[index]);
            } else {
              this.Detail.push(statusPages[index]);
            }
          });
          // look for url params after processing PageStatus data
          this.lookForQueryParams();
        }
      );
  }

  lookForQueryParams(): void {
    this.route.queryParams
      .subscribe(params => {
          // if there are url parameters, we want to be on the 'Detail' tab.
          if (params.tabIndex) {
            this.selectedIndex = 1;
          }
        }
      );
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    // if on Summary tab (index 0) remove url params
    if (tabChangeEvent.index === 0){
      window.location.href = window.location.href.split('?')[0];
    }
  }

}
